import React, { useEffect, useRef, useState } from 'react'
import './Dividend.scss'
import { DividendApi } from "../../../services/dividend/api";
import { Configuration } from "../../../services/dividend/configuration";
import { useSelector } from "react-redux";


import Spinner from '../../../components/spinner';
import moment from 'moment';
import DataTableComponent from '../../../components/dataTables/dataTable';
import { Toast } from 'primereact/toast';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
import ErrorWithReload from '../../../components/charts/ErrorWithReload';
export default function StockAnalysisDividend() {
    const { t } = useTranslation();
    const toast = useRef(null);
    const api = new DividendApi(new Configuration({ basePath: process.env.REACT_APP_DIVIDEND_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_DIVIDEND_API_BASE_PATH));
    const user = useSelector((state) => state.auth?.user);
    const token = useSelector((state) => state.auth?.token);
    const accountId = useSelector((state) => state.auth?.accountId);

    const [gridData, setGridData] = useState(null);
    const [entityId, setEntityId] = useState("TUPRS");
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const [panelError, setPanelError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [dividendTableColumnsData, setDividendTableColumnsData] = useState([]);


    const summaryTableDataColumnsChartView = [
        { id: 1, field: 'paymentDate', displayName: 'Tarih', header: t('tableHeader.date'), isVisible: true, width: '20%', align: 'center', sortable: false },
        { id: 2, field: 'netDividend', displayName: 'Hisse Başı Net Tutar (TL)', header: t('tableHeader.netAmountPerShare') + ' (TL)', isVisible: true, width: '20%', align: 'right', sortable: true },
        { id: 3, field: 'dividendYield', displayName: 'Temettü Verimi (%)', header: t('tableHeader.dividendYield-2') + ' (%)', isVisible: true, width: '20%', align: 'right', sortable: true },
        { id: 4, field: 'threeYearRatioCAGR', displayName: 'Temettü Yıllık Büyümesi Oranı (%)', header: t('tableHeader.dividendAnnualGrowthRate') + ' (%)', isVisible: true, width: '20%', align: 'right', sortable: true },
        { id: 5, field: 'distributeRatio', displayName: 'Yıllık Kar Dağıtma Oranı (%)', header: t('tableHeader.annualProfitDistributionRate') + ' (%)', isVisible: true, width: '20%', align: 'right', sortable: true }
    ]

    useEffect(() => {
        setDividendTableColumnsData(summaryTableDataColumnsChartView);
    }, [])

    useEffect(() => {


        if (selectedSecurity.code) {
            setEntityId(selectedSecurity.code);
            getDividendData();
        }
    }, [selectedSecurity.code])



    //#region API CALLS
    //#region DIVIDENDDATA

    const getDividendData = () => {
        setIsLoading(true);
        setPanelError(false);

        if (!token || !entityId) {
            setPanelError(true);
            setIsLoading(false);
            return;
        }

        api.apiDividendAnalysisGet(selectedSecurity.code, token).then((res) => {
            if (!res.data) {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('noDataTable') });
                setPanelError(true);
                setIsLoading(false);
                return;
            }

            let data = res.data;
            let formattedData = [];
            data.forEach((it) => {
                let formattedDate = moment(it.paymentDate).format("DD.MM.YYYY");
                console.log("formattedDate:", formattedDate);
                let obj = {
                    paymentDate: it.paymentDate,
                    netDividend: parseFloat(it.netDividend).toFixed(2) === 'NaN' ? '' : parseFloat(it.netDividend).toFixed(2),
                    threeYearRatioCAGR: parseFloat(it.dividendCAGR).toFixed(2) === 'NaN' ? '' : parseFloat(it.dividendCAGR).toFixed(2),
                    dividendYield: parseFloat(it.dividendYieldAvg).toFixed(2) === 'NaN' ? '' : parseFloat(it.dividendYieldAvg).toFixed(2),
                    distributeRatio: parseFloat(it.yearlyPayoutRatio).toFixed(2) === 'NaN' ? '' : parseFloat(it.yearlyPayoutRatio).toFixed(2),
                };
                formattedData.push(obj);
            });
            console.log("formattedData:", formattedData);
            setGridData(formattedData);
            setIsLoading(false);

        }).catch((err) => {
            console.error("Dividend data error:", err);
            setPanelError(true);
            setIsLoading(false);
        });


    }

    //#endregion DIVIDENDDATA
    //#endregion API CALLS


    return (
        <div id='stockAnalysisDividend'>
            <Toast ref={toast} position={'bottom-right'} />

            <div className='table-chart-view stock-analysis-dividend-table'>
                {isLoading && <Spinner height="400px" />}
                {!isLoading && panelError && (
                    <ErrorWithReload
                        height="400px"
                        onReload={() => getDividendData()}
                        errorMessage={t('aserviceRelatedErrorOccurred')}
                    />
                )}
                {!isLoading && !panelError && (
                    <DataTableComponent
                        columnsProp={summaryTableDataColumnsChartView}
                        dataProp={gridData}
                        search={false}
                        columnsSelect={false}
                    />
                )}
            </div>
        </div>
    )
}
